import { useTranslation } from 'react-i18next';
import { mainSiteUrl } from '@/mocks/categories';

export default function ComparisonSection() {
  const { t } = useTranslation();

  const comparisons = [
    {
      titleKey: 'comparison.card1.title',
      pros: ['comparison.card1.pro1', 'comparison.card1.pro2', 'comparison.card1.pro3', 'comparison.card1.pro4'],
      highlight: true,
    },
    {
      titleKey: 'comparison.card2.title',
      pros: ['comparison.card2.pro1', 'comparison.card2.pro2', 'comparison.card2.pro3', 'comparison.card2.pro4'],
      highlight: false,
    },
    {
      titleKey: 'comparison.card3.title',
      pros: ['comparison.card3.pro1', 'comparison.card3.pro2', 'comparison.card3.pro3', 'comparison.card3.pro4'],
      highlight: false,
    },
  ];

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4 mb-12 md:mb-16">
          <div>
            <span className="inline-block text-xs font-medium text-accent-500 uppercase tracking-widest mb-3">
              Vergleich
            </span>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
              {t('comparison.subtitle')}
            </h2>
          </div>
          <p className="text-sm md:text-base text-foreground-600 max-w-md">
            {t('comparison.desc')}
          </p>
        </div>

        {/* Comparison cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {comparisons.map((comp) => (
            <div
              key={comp.titleKey}
              className={`rounded-2xl p-8 ${
                comp.highlight
                  ? 'bg-accent-600 text-background-50 ring-2 ring-accent-500'
                  : 'bg-background-100 text-foreground-900'
              }`}
            >
              <h3 className={`font-heading text-xl font-bold mb-6 ${comp.highlight ? 'text-background-50' : 'text-foreground-950'}`}>
                {t(comp.titleKey)}
              </h3>
              <ul className="space-y-3">
                {comp.pros.map((proKey) => (
                  <li key={proKey} className="flex items-start gap-2.5">
                    <span className={`mt-0.5 flex-shrink-0 ${comp.highlight ? 'text-accent-300' : 'text-accent-500'}`}>
                      <i className="ri-check-line text-sm"></i>
                    </span>
                    <span className={`text-sm ${comp.highlight ? 'text-background-50/80' : 'text-foreground-600'}`}>
                      {t(proKey)}
                    </span>
                  </li>
                ))}
              </ul>
              {comp.highlight && (
                <a
                  href={mainSiteUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="mt-6 inline-flex items-center gap-2 w-full justify-center px-6 py-3 rounded-full bg-background-50 text-accent-600 text-sm font-semibold hover:bg-background-50/90 transition-all cursor-pointer whitespace-nowrap"
                >
                  Zum Spreadsheet
                  <i className="ri-arrow-right-line"></i>
                </a>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}